import { render, staticRenderFns } from "./EditDocuments.vue?vue&type=template&id=6fc0ab09&"
import script from "./EditDocuments.vue?vue&type=script&lang=js&"
export * from "./EditDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports